import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Landing from './views/Landing.vue'
import Share from './views/Share.vue'
import Terms from './views/Terms.vue'
import Privacy from './views/Privacy.vue'
// Admin Components
import Hello from './views/admin/Hello.vue'
import Users from './views/admin/Users.vue'
import Articles from './views/admin/Articles.vue'
import Outfits from './views/admin/Outfits.vue'
import Login from './views/admin/Login.vue'

import VueGtm from 'vue-gtm';


Vue.use(Router)

import {auth} from "./firebaseConfig";

let router =  new Router({
  mode:'history',
  routes: [
    {
      path: '*',
      redirect: '/',
      component:Landing
      
    },
    {
      path: '/',
      name: 'Home',
      component: Landing,
      meta: {
        title: 'What Wear and When - Home',
        metaTags: [
          {
            name: 'description',
            content: 'Your wardrobe calendar app.'
          },
          {
            property: 'og:description',
            content: 'Your wardrobe calendar app.'
          }
        ]
      } 
    },
    {
      path: '/share',
      name: 'Share',
      component: Share,
      meta: {
        title: 'What Wear and When - Share',
        metaTags: [
          {
            name: 'description',
            content: 'Your wardrobe calendar app.'
          },
          {
            property: 'og:description',
            content: 'Your wardrobe calendar app.'
          }
        ]
      }
    },
    {
      path: '/terms',
      name: 'Terms',
      component: Terms,
      meta: {
        title: 'What Wear and When - Terms',
        metaTags: [
          {
            name: 'description',
            content: 'Your wardrobe calendar app.'
          },
          {
            property: 'og:description',
            content: 'Your wardrobe calendar app.'
          }
        ]
      }
    },
    { 
      path: '/terms.html', 
      redirect: '/terms' 
    },
    {
      path: '/privacy',
      name: 'Privacy',
      component: Privacy,
      meta: {
        title: 'What Wear and When - Privacy',
        metaTags: [
          {
            name: 'description',
            content: 'Your wardrobe calendar app.'
          },
          {
            property: 'og:description',
            content: 'Your wardrobe calendar app.'
          }
        ]
      }
    },
    { 
      path: '/privacy.html', 
      redirect: '/privacy' 
    },
    {
      path: '/admin/hello',
      name: 'Hello',
      component: Hello,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/admin/users',
      name: 'Users',
      component: Users,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/admin/articles',
      name: 'Articles',
      component: Articles,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/admin/outfits',
      name: 'Outfits',
      component: Outfits,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/admin/login',
      name: 'Login',
      component: Login
    },
  ]
});
router.beforeEach((to, from, next) => {
  const currentUserAuth = auth.currentUser;
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  console.log("req auth: ", requiresAuth);
  console.log("current user: ", currentUserAuth);
  if(requiresAuth && !currentUserAuth) next ('/admin/login');
  else if (!requiresAuth && currentUserAuth) next ('/admin/hello');
  else next();
});

Vue.use(VueGtm, {
  id: 'GTM-5Q8RKFV', // Your GTM ID
  enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
  debug: false, // Whether or not display console logs debugs (optional)
  vueRouter: router, // Pass the router instance to automatically sync with router (optional)
});

export default router
